import { render, staticRenderFns } from "./sVideo.vue?vue&type=template&id=10e20bda&scoped=true&"
import script from "./sVideo.vue?vue&type=script&lang=js&"
export * from "./sVideo.vue?vue&type=script&lang=js&"
import style0 from "./sVideo.vue?vue&type=style&index=0&id=10e20bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e20bda",
  null
  
)

export default component.exports